import { Fragment, ReactElement, useMemo } from 'react';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import PersonsPageNonResident from 'mutation/pages/registration-marriage/non-resident/search-person';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { ResearchNotifications } from 'notifications-from-civil-status/view-models/notifications-list';

interface ResearchMarriageNonResidentNotificationsSharedProps {
  goBackUrl?: string;
  editSipoUrl?: string;
  redirectUrl?: string;
  items?: BreadcrumbItem[];
}

const ResearchMarriageNonResidentNotificationsShared = ({
  goBackUrl = '',
  editSipoUrl = '',
  redirectUrl = '',
  items = [],
}: ResearchMarriageNonResidentNotificationsSharedProps): ReactElement => {
  const filterTable = useFilterTable<ResearchNotifications>();

  const initialValues = useMemo(() => {
    return {
      fiscalCode: filterTable.values?.searchPersonFiscalCode,
      surname: filterTable.values?.searchPersonSurname,
      name: filterTable.values?.searchPersonName,
      birthday: filterTable.values?.searchPersonDateBorn,
    };
  }, [filterTable.values]);

  return (
    <Fragment>
      <Breadcrumbs items={items} />
      <PersonsPageNonResident
        addedTitle="Registrazione Matrimonio Non Residenti"
        goBackUrl={goBackUrl}
        editSipoUrl={editSipoUrl}
        redirectUrl={redirectUrl}
        isWithoutBreadcrumb
        initialValues={initialValues}
      />
    </Fragment>
  );
};

ResearchMarriageNonResidentNotificationsShared.displayName =
  'Research Marriage Non Resident Notifications Shared component';

export default ResearchMarriageNonResidentNotificationsShared;
